module.exports = __webpack_public_path__ + "static/media/icn_menu_light.552582c7.svg";